import store from '../../state';
import {
  selectCurrentDashboard,
  selectIsDashboardMode,
  dashboardAuthHeader
} from '../../state/modules/dashboards/selectors';

// this is the group scope in which data can be accessed. It is used to limit
// many API calls below, to increase performance.
export const getAccessScopeGroupIds = () =>
  new Promise(resolve => {
    const check = () => {
      // if we're not in dashboard mode, then there is no access scope group,
      // and we can just return null. This is needed to avoid an infinite loop
      // when trying to get the access scope group ids before we know whether
      // we're in dashboard mode or not.
      if (!selectIsDashboardMode(store.getState())) return resolve(null);

      // current dashboard won't be null, but it will be empty. See dashboard
      // selectors
      const currentDashboard = selectCurrentDashboard(store.getState());
      if (currentDashboard.system_template) {
        resolve(null);
      } else if (currentDashboard.id) {
        const result = currentDashboard.access_scope_group_ids || [];
        if (result.length > 0) {
          resolve(result);
        } else if (currentDashboard.group_id) {
          resolve([currentDashboard.group_id].filter(Boolean));
        } else {
          resolve(null);
        }
      } else {
        setTimeout(check, 100);
      }
    };
    check();
  });

// returns a promise which resolves to the auth header needed to access
// dashboard data
export const getAuthHeader = () =>
  new Promise(resolve => {
    const waitForToken = () => {
      const token = store.getState().dashboards.dashboardReadAuthToken;
      const currentDashboard = selectCurrentDashboard(store.getState());
      const isDashboardMode = selectIsDashboardMode(store.getState());
      if (currentDashboard.system_template) {
        resolve(null);
      } else if (token === undefined && isDashboardMode) {
        setTimeout(waitForToken, 100);
      } else {
        resolve(dashboardAuthHeader(store.getState()));
      }
    };
    waitForToken();
  });
